export default "__VITE_ASSET__C8N1jure__"